import { PostStandbyCompleteEntryResponse } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { StandbyEntryCompletionResultModel } from './standby-entry-completion-result.state';

/** StateDetailsActions */
const ACTION_SET = '[StandbyEntryCompletionResult] set';
const ACTION_UPDATE = '[StandbyEntryCompletionResult] update';
const ACTION_RESET = '[StandbyEntryCompletionResult] reset';
const ACTION_FAIL = '[StandbyEntryCompletionResult] fail';
const ACTION_CANCEL_REQUEST = '[StandbyEntryCompletionResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[StandbyEntryCompletionResult] set from api';
const ACTION_UPDATE_FROM_API = '[StandbyEntryCompletionResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setStandbyEntryCompletionResult = createAction(
  ACTION_SET,
  props<WithRequestId<StandbyEntryCompletionResultModel>>()
);

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateStandbyEntryCompletionResult = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<StandbyEntryCompletionResultModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetStandbyEntryCompletionResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelStandbyEntryCompletionResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failStandbyEntryCompletionResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setStandbyEntryCompletionResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostStandbyCompleteEntryResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateStandbyEntryCompletionResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostStandbyCompleteEntryResponse>>()
);
